import { QrCodeScanner as ScannerIcon } from '@mui/icons-material';
import { Option } from '@/components/inputs/AutocompleteInput';
import DriverSelector from './ScannerPanel/DriverSelector';
import { useSearchParams } from 'react-router-dom';
import CodeInput from './ScannerPanel/CodeInput';
import { ToggleSwitch } from '@/components';
import { SectionHeader } from '../';
import React from 'react';

interface ScannerPanelProps {
  driver: Option | null;
  setDriver: (option: Option | null) => void;
  setDriverSearch: (search: string) => void;
  driverOptions: Option[];
  isDriversLoading: boolean;
  inputValue: string;
  setInputValue: (val: string) => void;
  isScannerActive: boolean;
  setIsScannerActive: (active: boolean) => void;
  isSearchingShipping: boolean;
  inputRef: React.RefObject<HTMLInputElement>;
  onScan: (event: React.KeyboardEvent) => void;
}

const ScannerPanel = ({
  driver,
  setDriver,
  setDriverSearch,
  driverOptions,
  isDriversLoading,
  inputValue,
  setInputValue,
  isScannerActive,
  setIsScannerActive,
  isSearchingShipping,
  inputRef,
  onScan,
}: ScannerPanelProps) => {
  const [searchParams] = useSearchParams();
  const isManual = searchParams.get('manual') === 'true';

  return (
    <div className='bg-white rounded-xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8'>
      <div className='flex items-center justify-between mb-2'>
        <SectionHeader
          title={isManual ? 'Creación Manual' : 'Panel de Escaneo'}
          icon={ScannerIcon}
          colorClass='bg-[#ff7500]'
          subtitle={
            isManual
              ? 'Escanea los pedidos que se cancelaron antes de salir a ruta'
              : undefined
          }
        />

        <div className='flex items-center gap-4'>
          <span
            className={`text-[11px] font-black uppercase tracking-widest ${
              isScannerActive ? 'text-orange-600' : 'text-gray-400'
            }`}
          >
            {isScannerActive ? 'Lector Conectado' : 'Lector Pausado'}
          </span>
          <ToggleSwitch
            checked={isScannerActive}
            onChange={setIsScannerActive}
            ariaLabel='Activar/Desactivar Lector'
          />
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6 items-end'>
        <DriverSelector
          driver={driver}
          setDriver={setDriver}
          setDriverSearch={setDriverSearch}
          driverOptions={driverOptions}
          isDriversLoading={isDriversLoading}
        />

        <CodeInput
          inputValue={inputValue}
          setInputValue={setInputValue}
          onScan={onScan}
          isScannerActive={isScannerActive}
          setIsScannerActive={setIsScannerActive}
          isSearchingShipping={isSearchingShipping}
          inputRef={inputRef}
        />
      </div>
    </div>
  );
};

export default ScannerPanel;
